// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__QGb3M","backdrop":"Modal_backdrop__AS6dq","header":"Modal_header__lZlOI","closeIcon":"Modal_closeIcon__Y2FRG","content":"Modal_content__Y2phq"};